import * as actionTypes from './actionTypes';
import HttpClient from "../../_services/httpClient";
import * as errorHandlerActions from './errorHandlerActions';
import {finishLoading, startLoading} from "./uiActions";

export const getData = (url, props) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    dispatch(getDataSuccess(response.data));

                    resolve(response);
                })
                .catch(error => {
                    let errorDescription = error.response?.data?.errors?.message ?? error.message;
                    dispatch(finishLoading());
                    dispatch(errorHandlerActions.handleHTTPError(errorDescription, props));

                    eject(errorDescription);
                })
        });

    }
}

const getDataSuccess = (data) => {
    return {
        type: actionTypes.GET_DATA_SUCCESS,
        data: data
    }
}

export const postData = (url, obj, props) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            HttpClient.post(url, obj)
                .then(response => {
                    dispatch(finishLoading());
                    dispatch(postDataSuccess(response));

                    resolve(response);
                })
                .catch(error => {
                    let errorDescription = error.response?.data?.errors?.message ?? error.message;

                    dispatch(finishLoading());
                    dispatch(errorHandlerActions.handleHTTPError(errorDescription, props));

                    eject(errorDescription);
                })
        });

    }
}

const postDataSuccess = (response) => {
    return {
        type: actionTypes.POST_DATA_SUCCESS,
        response: response
    }
}

export const putData = (url, obj, props) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            HttpClient.put(url, obj)
                .then(response => {
                    dispatch(finishLoading());
                    dispatch(putDataSuccess(response));

                    resolve(response);
                })
                .catch(error => {
                    let errorDescription = error.response?.data?.errors?.message ?? error.message;

                    dispatch(finishLoading());
                    dispatch(errorHandlerActions.handleHTTPError(errorDescription, props));

                    eject(errorDescription);
                })
        });
    }
}

const putDataSuccess = (response) => {
    return {
        type: actionTypes.PUT_DATA_SUCCESS,
        response: response
    }
}

export const deleteData = (url, props) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            HttpClient.delete(url)
                .then(response => {
                    dispatch(finishLoading());
                    dispatch(deleteDataSuccess(response));

                    resolve(response);
                })
                .catch(error => {
                    let errorDescription = error.response?.data?.errors?.message ?? error.message;

                    dispatch(finishLoading());
                    dispatch(errorHandlerActions.handleHTTPError(errorDescription, props));

                    eject(errorDescription);
                })
        });
    }
}

const deleteDataSuccess = (response) => {
    return {
        type: actionTypes.DELETE_DATA_SUCCESS,
        response: response
    }
}

export const savePartnerID = (value) => {
    return {
        type: actionTypes.SAVE_PARTNER_ID,
        payload: value
    }
};

export const savePartner = (value) => {
    return {
        type: actionTypes.SAVE_PARTNER,
        payload: value
    }
};
